import { QuotePreview } from "@/components/landing/QuotePreview";
import { CategoriesShowcase } from "@/components/landing/CategoriesShowcase";
import { FAQ } from "@/components/landing/FAQ";
export default function Home() {
  return <div className="container mx-auto px-4 py-[20px]">
      <section className="lg:py-16 py-[20px]">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Daily Wisdom, <span className="text-blue-500">Delivered</span> to Your Phone</h1>
          
          <h2 className="text-xl font-medium mb-6">✨ Start Your Day with Spark</h2>
          
          <p className="text-lg mb-6 text-left">
            Discover daily inspiration through carefully chosen quotes from legendary books 
            and brilliant minds. Whether you need a spark of motivation, a moment of 
            reflection, or a gentle nudge of wisdom — we've got you.
          </p>
          
          <div className="space-y-4 text-lg mb-8">
            <p className="text-left">🕒 Set your schedule: Morning, afternoon, or evening</p>
            <p className="text-left">📱 Choose your flow: One quote or a handful</p>
            <p className="text-left">💬 Tailored to you: Quotes that match your interests and goals</p>
          </div>
          
          <p className="text-xl italic mb-10">Let wisdom meet your rhythm.</p>
          
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-12">
            <a href="/verify" className="inline-flex justify-center items-center px-6 py-3 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition-colors">
              Get Started
            </a>
            <a href="#categories" className="inline-flex justify-center items-center px-6 py-3 bg-white border border-gray-300 text-gray-700 font-medium rounded-md hover:bg-gray-50 transition-colors">
              Learn More
            </a>
          </div>
          
          <QuotePreview />
        </div>
      </section>
      
      <section id="categories" className="py-12 bg-primary/5 rounded-lg my-12">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-8">Explore Our Categories</h2>
          <CategoriesShowcase />
        </div>
      </section>
      
      <section className="py-[24px]">
        <FAQ />
      </section>
    </div>;
}